import store from '@/store'

function isAdmin() {
  const info = store.getters && store.getters['user/userInfo']
  return Boolean(info && info.role === 'admin')
}

function apply(el, binding) {
  // 支持传参：v-admin="true/false"，false 时强制隐藏
  if (binding && binding.value === false) {
    if (el && el.parentNode) el.parentNode.removeChild(el)
    return
  }

  if (!isAdmin()) {
    if (el && el.parentNode) el.parentNode.removeChild(el)
  }
}

export default {
  inserted(el, binding) {
    apply(el, binding)
  },
  update(el, binding) {
    // 用户信息可能异步更新；update 里兜底更新一次
    apply(el, binding)
  }
}

